import React from 'react'
import { Box, Typography } from '@mui/material'
import { Navbar } from '../../components/Navbar/Navbar'
import { ItemsList } from './components/ItemList/ItemList'
import { useWindowWidth } from '../../hooks/useWindowWidth'

export const ItemsIndex = () => {
  const windowWidth = useWindowWidth()
  return (
    <>
      <Navbar />
      <Box
        sx={{
          paddingLeft: '24px',
          marginTop: '16px',
          display: 'flex',
          justifyContent: 'space-between',
        }}
      >
        <Typography variant="h4" component="h4">
          Przedmioty
        </Typography>
      </Box>

      <Box sx={{ paddingRight: '24px', paddingLeft: '24px' }}>
        <ItemsList columns={Math.round(windowWidth / 400)} />
      </Box>
    </>
  )
}
